import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import { AutoSizer } from 'react-virtualized';
import { TimebarChart } from './chart.tsx';
import timebarStyleNames from './styles.less';
import { PlayMenu } from './playmenu';

export function Timebar({
    id,
    name,
    width,
    height,
    loading,
    onClose,
    onWheel,
    onLoading,
    isPanZooming,
    isPanScrolling,
    isBrushFiltering,
    styleNames = timebarStyleNames,
    ...props
}) {
    onLoading && onLoading(!!loading);
    return (
        <div
            onWheel={onWheel}
            style={{ width: width + 20, height: height + 10 }}
            className={classNames({
                [styleNames['timebar']]: true,
                [styleNames['is-pan-zooming']]: !!isPanZooming,
                [styleNames['is-pan-scrolling']]: !!isPanScrolling,
                [styleNames['is-brush-filtering']]: !!isBrushFiltering
            })}>
            <PlayMenu {...props}></PlayMenu>
            <TimebarChart
                {...props}
                name={name}
                height={height - 50}
                width={width - 20}
                loading={loading}
                styleNames={styleNames}
                isPanZooming={isPanZooming}
                isPanScrolling={isPanScrolling}
            />
        </div>
    );
}
